// French strings of the administration panel (web/ui/admin.js and web/ui/admin/*.js). Registered at
// module load; keys are prefixed "adm." so they never collide with the shell dictionary.
import { registerStrings } from '../../i18n/fr.js';

registerStrings({
  // Sheet
  'adm.eyebrow': 'RÉSERVÉ À L’ADMINISTRATEUR',
  'adm.refresh': 'Actualiser',
  'adm.retry': 'Réessayer',
  'adm.loading': 'Chargement…',
  'adm.unavailable': 'Pas encore disponible sur ce serveur.',
  'adm.loadError': 'Chargement impossible',
  'adm.saved': 'Modifications enregistrées.',
  'adm.formError': 'Corrigez les champs signalés.',
  'adm.counter': '{n} / {max}',
  'adm.copy': 'COPIER',
  'adm.copied': 'Copié.',
  'adm.copyManual': 'Sélectionnez le texte puis copiez-le (⌘C ou Ctrl+C).',
  'adm.you': 'vous',
  'adm.never': 'Jamais',
  'adm.none': '—',
  'adm.moveUp': 'Monter « {name} »',
  'adm.moveDown': 'Descendre « {name} »',
  'adm.actions': 'Actions',

  // Levels (grants): plain words, with a legend
  'adm.level.view': 'Voir',
  'adm.level.operate': 'Utiliser',
  'adm.level.manage': 'Gérer',
  'adm.level.admin': 'Tout',
  'adm.legend.title': 'Que permet chaque niveau ?',
  'adm.legend.view': 'Voit l’étage ou le service : ses agents, ses tâches et leurs résultats, les fichiers et le calendrier. Ne peut rien lancer ni modifier.',
  'adm.legend.operate': 'Tout ce que permet « Voir », plus : lancer des tâches, discuter avec les agents, valider ou refuser leurs brouillons, annuler ou relancer une tâche, lancer une routine tout de suite.',
  'adm.legend.manage': 'Tout ce que permet « Utiliser », plus : régler les agents (consignes, moteur, connecteurs, autonomie, règles apprises), créer et modifier les routines et les déclencheurs n8n, modifier les notes de l’étage, supprimer des tâches.',
  'adm.legend.admin': 'Un administrateur a toujours accès à tout, y compris cette administration et l’Atelier.',

  // Users
  'adm.users.title': 'Utilisateurs',
  'adm.users.count': { one: '{n} compte', other: '{n} comptes' },
  'adm.users.intro': 'Chaque personne a son propre compte. Un membre ne voit que les étages et services que vous lui ouvrez.',
  'adm.users.new': 'NOUVEL UTILISATEUR',
  'adm.users.search': 'Rechercher un utilisateur',
  'adm.users.col.name': 'Nom',
  'adm.users.col.role': 'Rôle',
  'adm.users.col.grants': 'Accès',
  'adm.users.col.lastLogin': 'Dernière connexion',
  'adm.users.col.status': 'Statut',
  'adm.users.personal': 'AJOUTE DES CONNECTEURS',
  'adm.users.personalHint': 'Peut ajouter des connecteurs à la bibliothèque du bureau (Canva, adresse MCP) et gérer ceux qu’il a ajoutés.',
  'adm.users.limited': 'CONNECTEURS LIMITÉS',
  'adm.users.limitedHint': 'Connecteurs du bureau : {summary}.',
  'adm.users.edit': 'MODIFIER',
  'adm.users.editAria': 'Modifier {name}',
  'adm.users.empty': 'Aucun utilisateur ne correspond à cette recherche.',
  'adm.users.unavailable': 'La gestion des utilisateurs n’est pas encore disponible sur ce serveur.',
  'adm.status.active': 'ACTIF',
  'adm.status.disabled': 'DÉSACTIVÉ',
  'adm.status.mustChange': 'MOT DE PASSE TEMPORAIRE',
  'adm.status.mustChangeHint': 'Cette personne ne s’est pas encore connectée avec son propre mot de passe.',
  'adm.grants.admin': 'Tout (administrateur)',
  'adm.grants.none': 'Aucun accès',
  'adm.grants.allFloor': 'tout l’étage',
  'adm.grants.item': '{floor} · {dept} ({level})',
  'adm.grants.more': '+{n}',
  'adm.grants.unknownFloor': 'Étage supprimé ({id})',
  'adm.grants.unknownDept': 'Service supprimé ({id})',

  // User form
  'adm.user.createTitle': 'Nouvel utilisateur',
  'adm.user.createSubtitle': 'Un mot de passe temporaire est créé : vous le transmettez, la personne le change à sa première connexion.',
  'adm.user.username': 'Identifiant',
  'adm.user.usernameHint': 'Pour se connecter. 2 à 32 caractères : minuscules, chiffres, point, tiret, tiret bas. Ne pourra plus être changé.',
  'adm.user.displayName': 'Nom affiché',
  'adm.user.displayNameHint': 'Le nom que les autres voient (par défaut : l’identifiant).',
  'adm.user.role': 'Rôle',
  'adm.user.role.member': 'Membre',
  'adm.user.role.admin': 'Administrateur',
  'adm.user.roleHint.member': 'N’accède qu’aux étages et services que vous lui ouvrez ci-dessous.',
  'adm.user.roleHint.admin': 'Accès complet : tous les étages, l’administration et l’Atelier. À réserver aux personnes de confiance.',
  'adm.user.grants': 'Accès',
  'adm.user.grantsAdmin': 'Un administrateur a accès à tout : pas besoin de régler ses accès.',
  'adm.user.personal': 'Peut ajouter des connecteurs',
  'adm.user.personalHint': 'Ce qu’il ajoute (Canva, adresse MCP) va dans la bibliothèque du bureau : sur tous les étages, utilisable par toutes les personnes autorisées. Ce qu’il ajoute est autorisé pour lui d’office ; il peut connecter, vérifier, renommer et retirer ses propres ajouts.',
  'adm.user.personalOff': 'La bibliothèque de connecteurs n’est pas activée sur ce serveur : ce réglage s’appliquera quand elle le sera.',
  'adm.user.personalAdmin': 'Un administrateur peut toujours ajouter des connecteurs et se servir de tous.',
  // « Connecteurs autorisés » (connector policy of a member)
  'adm.user.conns': 'Connecteurs autorisés',
  'adm.user.connsHint': 'Les connecteurs du bureau dont les agents peuvent se servir pour cette personne : ses tâches et discussions, les brouillons qu’elle valide, les routines qu’elle modifie, et son Claude branché par une clé personnelle (MCP). S’ajoute aux réglages des étages et des agents, sans jamais les élargir.',
  'adm.user.conns.all': 'Tous',
  'adm.user.conns.except': 'Tous sauf…',
  'adm.user.conns.only': 'Seulement…',
  'adm.user.connsMode.all': 'Tous les connecteurs autorisés sur ses étages.',
  'adm.user.connsMode.except': 'Cochez les connecteurs interdits. Un connecteur détecté ou ajouté plus tard sera permis.',
  'adm.user.connsMode.only': 'Cochez les connecteurs permis. Un connecteur détecté ou ajouté plus tard restera interdit (sauf ceux qu’il ajoute lui-même) : le plus sûr pour un accès sensible.',
  'adm.user.connsOnlyNone': 'Aucun connecteur coché : ses demandes se feront sans connecteur extérieur.',
  'adm.user.connsNotConcerned': 'Ne concerne pas les Tables du bureau (toujours disponibles). Les connecteurs ajoutés dans le bureau en font partie (« ajouté par … ») ; ceux qu’il ajoute lui-même sont autorisés pour lui d’office.',
  'adm.user.connsKeysHint': 'Un même service peut exister en plusieurs exemplaires (claude.ai GitHub, github, codex-github) : une ligne les coche tous. Un connecteur renommé change de clé : vérifiez ce réglage après un renommage, et préférez « Seulement… » pour un accès sensible.',
  'adm.user.connsAdmin': 'Connecteurs du bureau : un administrateur peut toujours tous les utiliser.',
  'adm.user.connsLoading': 'Chargement des connecteurs…',
  'adm.user.connsUnavailable': 'Liste des connecteurs indisponible : le réglage actuel ({summary}) est conservé.',
  'adm.user.connsNone': 'Aucun connecteur pour l’instant (Administration → Connecteurs : ACTUALISER, ou AJOUTER UN CONNECTEUR).',
  'adm.user.connsUnknown': 'n’est plus détecté',
  'adm.user.connsLibrary': 'ajouté par {name} · tous les étages',
  'adm.user.connsLibraryNoName': 'ajouté dans le bureau · tous les étages',
  'adm.user.connsLibraryGone': 'retiré de la bibliothèque',
  'adm.user.connsPartial': 'en partie : {keys}',
  'adm.user.connsFilter': 'Filtrer les connecteurs',
  'adm.user.connsNoMatch': 'Aucun connecteur ne correspond.',
  'adm.user.create': 'CRÉER L’UTILISATEUR',
  'adm.user.created': 'Compte « {username} » créé.',
  'adm.user.editTitle': '{name}',
  'adm.user.editSubtitle': '@{username} · compte créé {created}',
  'adm.user.active': 'Compte actif',
  'adm.user.activeHint': 'Désactivé, le compte ne peut plus se connecter et ses sessions sont fermées. Rien n’est supprimé.',
  'adm.user.selfHint': 'C’est votre compte : vous ne pouvez ni retirer votre rôle d’administrateur, ni le désactiver, ni le supprimer.',
  'adm.user.password': 'Mot de passe',
  'adm.user.resetPassword': 'RÉINITIALISER LE MOT DE PASSE',
  'adm.user.resetHint': 'Crée un nouveau mot de passe temporaire et ferme toutes les sessions de cette personne.',
  'adm.user.resetSelf': 'Pour votre propre compte, utilisez « Changer le mot de passe » dans le menu de votre compte.',
  'adm.user.resetConfirmTitle': 'Réinitialiser le mot de passe ?',
  'adm.user.resetConfirm': '{name} sera déconnecté(e) partout et devra se connecter avec le nouveau mot de passe temporaire.',
  'adm.user.resetConfirmLabel': 'RÉINITIALISER',
  'adm.user.danger': 'Zone sensible',
  'adm.user.delete': 'SUPPRIMER L’UTILISATEUR',
  'adm.user.deleteHint': 'Supprime définitivement le compte. Pour suspendre un accès sans rien perdre, désactivez plutôt le compte.',
  'adm.user.deleteConfirmTitle': 'Supprimer {name} ?',
  'adm.user.deleteConfirm': 'Le compte « {username} » sera supprimé définitivement, avec ses clés d’accès Claude (MCP). Les connecteurs qu’il a ajoutés restent dans la bibliothèque du bureau. Cette action est irréversible.',
  'adm.user.deleted': 'Compte « {username} » supprimé.',
  'adm.user.mustChangeNote': 'Mot de passe temporaire : pas encore changé par la personne.',
  'adm.user.lastLogin': 'Dernière connexion : {when}',
  'adm.user.noChange': 'Aucune modification à enregistrer.',

  // Temporary password
  'adm.temp.title': 'Mot de passe temporaire',
  'adm.temp.subtitle': 'Compte « {username} »',
  'adm.temp.label': 'Mot de passe temporaire',
  'adm.temp.once': 'Il ne sera plus jamais affiché : notez-le ou copiez-le maintenant.',
  'adm.temp.share': 'Transmettez-le à {name} par un canal sûr (de vive voix, SMS, gestionnaire de mots de passe), jamais dans un e-mail partagé.',
  'adm.temp.change': 'À sa première connexion, {name} devra choisir son propre mot de passe avant de pouvoir utiliser le bureau.',
  'adm.temp.done': 'J’AI NOTÉ LE MOT DE PASSE',

  // Grants editor
  'adm.grant.floor': 'Étage',
  'adm.grant.dept': 'Service',
  'adm.grant.level': 'Niveau',
  'adm.grant.allFloor': 'Tout l’étage',
  'adm.grant.add': 'AJOUTER UN ACCÈS',
  'adm.grant.remove': 'Retirer cet accès',
  'adm.grant.empty': 'Aucun accès : cette personne ne verra aucun étage.',
  'adm.grant.noFloors': 'Créez d’abord un étage dans « Étages & services ».',
  'adm.grant.rowAria': 'Accès n° {n}',
  'adm.grant.err.floor': 'Accès n° {n} : choisissez un étage.',
  'adm.grant.err.unknownFloor': 'Accès n° {n} : cet étage n’existe plus.',
  'adm.grant.err.dept': 'Accès n° {n} : ce service n’est pas sur cet étage.',
  'adm.grant.err.level': 'Accès n° {n} : choisissez un niveau.',
  'adm.grant.err.duplicate': 'Accès n° {n} : même étage et même service qu’un accès précédent.',

  // Validation
  'adm.err.required': 'Ce champ est obligatoire.',
  'adm.err.username': 'Identifiant invalide : 2 à 32 caractères parmi a-z, 0-9, « . », « - », « _ ».',
  'adm.err.tooLong': '{max} caractères maximum.',
  'adm.err.agentName': 'Nom en majuscules, 22 caractères maximum.',
  'adm.err.color': 'Choisissez une couleur.',
  'adm.err.dataFloor': 'Choisissez un étage de la liste.',

  // Floors & departments
  'adm.floors.title': 'Étages & services',
  'adm.floors.intro': 'Un étage est un projet ; ses services regroupent les agents. L’ordre ci-dessous est celui de l’ascenseur.',
  'adm.floors.new': 'NOUVEL ÉTAGE',
  'adm.floors.empty.title': 'Aucun étage',
  'adm.floors.empty.text': 'Créez le premier étage : un projet, avec ses services et ses agents.',
  'adm.floors.count': { one: '{n} étage', other: '{n} étages' },
  'adm.reseed.button': 'REPARTIR DU MODÈLE FOURNI…',
  'adm.reseed.buttonTitle': 'Remplacer l’organisation par celle du modèle fourni (config/seed/office.json)',
  'adm.reseed.title': 'Repartir du modèle fourni ?',
  'adm.reseed.text': 'Les étages, services, agents, routines et déclencheurs sont remplacés par l’organisation du modèle fourni (config/seed/office.json). Une sauvegarde de office.json, routines.json et triggers.json est écrite d’abord dans data/backup-<date>/. Les utilisateurs, les tâches, les notes et les discussions sont conservés ; les secrets des déclencheurs sont à regénérer.',
  'adm.reseed.confirmLabel': 'Pour confirmer, tapez le nom du bureau',
  'adm.reseed.confirmHint': 'Exactement : {name}',
  'adm.reseed.ok': 'REPARTIR DU MODÈLE',
  'adm.reseed.mismatch': 'Le nom ne correspond pas.',
  'adm.reseed.done': 'Organisation remplacée : {floors} étages, {departments} services, {agents} agents (sauvegarde {backup}).',
  // Structure export / import (web/ui/admin/structure.js)
  'adm.structure.exportButton': 'EXPORTER LA STRUCTURE',
  'adm.structure.exportButtonTitle': 'Télécharger étages, services, agents, routines, déclencheurs et tables dans un fichier JSON',
  'adm.structure.importButton': 'IMPORTER UNE STRUCTURE…',
  'adm.structure.importButtonTitle': 'Ajouter ou remplacer l’organisation à partir d’un fichier exporté',
  'adm.structure.exportTitle': 'Exporter la structure',
  'adm.structure.exportText': 'Le fichier contient les étages, services, agents (consignes, règles apprises, moteurs, connecteurs accordés, apparence), routines, déclencheurs (sans secret) et la définition des tables. Jamais de secret, de clé d’API, de compte IA, d’utilisateur, de mot de passe ni de tâche.',
  'adm.structure.withRows': 'Avec les données',
  'adm.structure.withRowsHint': 'Ajoute les lignes des Tables du bureau.',
  'adm.structure.download': 'TÉLÉCHARGER',
  'adm.structure.exported': 'Structure exportée : {floors} étages, {departments} services, {agents} agents ({file}).',
  'adm.structure.noDownload': 'Ce navigateur ne permet pas le téléchargement : utilisez l’outil structure_export de Claude (MCP).',
  'adm.structure.importTitle': 'Importer une structure',
  'adm.structure.importText': 'Choisissez un fichier exporté depuis un bureau (ou un exemple de config/seed/examples/). Un aperçu montre ce qui sera créé ou remplacé avant tout changement. Les déclencheurs arrivent désactivés, sans secret.',
  'adm.structure.file': 'Fichier de structure (.json)',
  'adm.structure.fileHint': 'Exporté depuis Administration → Étages & services.',
  'adm.structure.noFile': 'Choisissez un fichier exporté (.json).',
  'adm.structure.unreadable': 'Fichier illisible.',
  'adm.structure.mode': 'Que faire ?',
  'adm.structure.mode.add': 'Ajouter à la structure actuelle',
  'adm.structure.mode.replace': 'Remplacer toute la structure',
  'adm.structure.modeHint.add': 'Tout est ajouté avec de nouveaux identifiants ; rien de l’existant ne change.',
  'adm.structure.modeHint.replace': 'Étages, services, agents, routines et déclencheurs sont remplacés, après une sauvegarde dans data/backup-<date>/. Les utilisateurs, les tâches, les notes et les tables existantes sont conservés.',
  'adm.structure.preview': 'APERÇU',
  'adm.structure.doAdd': 'AJOUTER',
  'adm.structure.doReplace': 'REMPLACER LA STRUCTURE',
  'adm.structure.invalid': 'Import impossible : corrigez le fichier.',
  'adm.structure.created': 'Seront importés : {floors} étages, {departments} services, {agents} agents, {routines} routines, {triggers} déclencheurs, {tables} tables',
  'adm.structure.createdRows': ' ({rows} lignes)',
  'adm.structure.replaced': 'Remplacés (gardés dans la sauvegarde) : {floors} étages, {departments} services, {agents} agents, {routines} routines, {triggers} déclencheurs.',
  'adm.structure.renamed': '{n} identifiants renommés pour éviter les doublons : {list}',
  'adm.structure.newName': 'Le bureau prendra le nom « {name} ».',
  'adm.structure.doneAdd': 'Structure ajoutée : {floors} étages, {departments} services, {agents} agents.',
  'adm.structure.doneReplace': 'Structure remplacée : {floors} étages, {departments} services, {agents} agents (sauvegarde {backup}).',
  'adm.floor.num': 'ÉTAGE {n}',
  'adm.floor.depts': { one: '{n} service', other: '{n} services' },
  'adm.floor.agents': { one: '{n} agent', other: '{n} agents' },
  'adm.floor.connectors': 'Connecteurs : {list}',
  'adm.floor.noConnectors': 'Aucun connecteur autorisé',
  'adm.floor.libraryAll': 'Et sur tous les étages, ajoutés dans le bureau : {list}',
  'adm.floor.edit': 'MODIFIER',
  'adm.floor.editAria': 'Modifier l’étage « {name} »',
  'adm.floor.delete': 'Supprimer l’étage « {name} »',
  'adm.floor.deleteBlocked': 'Supprimez d’abord ses services.',
  'adm.floor.deleteTitle': 'Supprimer l’étage « {name} » ?',
  'adm.floor.deleteText': 'L’étage est vide : il disparaîtra de l’immeuble. Cette action est irréversible.',
  'adm.floor.deleted': 'Étage « {name} » supprimé.',
  'adm.floor.newDept': 'NOUVEAU SERVICE',
  'adm.floor.noDepts': 'Aucun service sur cet étage.',
  'adm.floor.createTitle': 'Nouvel étage',
  'adm.floor.editTitle': 'Étage « {name} »',
  'adm.floor.name': 'Nom',
  'adm.floor.namePlaceholder': 'ex. Ads & Marketing',
  'adm.floor.description': 'Description',
  'adm.floor.descriptionHint': 'Une phrase affichée dans l’immeuble et l’ascenseur.',
  'adm.floor.color': 'Couleur',
  'adm.floor.context': 'Contexte du projet',
  'adm.floor.contextHint': 'Lu par tous les agents de l’étage avant chaque tâche : le projet, la marque, les clients, le ton, les liens utiles.',
  'adm.floor.allowed': 'Connecteurs autorisés sur cet étage',
  'adm.floor.allowedHint': 'Les agents de l’étage ne pourront utiliser que ces connecteurs, en lecture ou en écriture selon leurs propres réglages.',
  'adm.floor.allowedNone': 'Aucun connecteur détecté. Actualisez l’onglet « Connecteurs ».',
  'adm.floor.allowedUnavailable': 'Liste des connecteurs indisponible : les choix actuels sont conservés.',
  'adm.floor.allowedUnknown': 'n’est plus détecté',
  'adm.floor.libraryHint': 'Ajoutés dans le bureau (Administration → Connecteurs, ou « Connecteurs ») : disponibles sur tous les étages, sans réglage ici. Chaque agent les reçoit dans ses réglages.',
  'adm.floor.everyFloor': 'TOUS LES ÉTAGES',
  'adm.floor.studio': 'Studio',
  'adm.floor.studioHint': 'Tous les services de cet étage peuvent créer et suivre des pubs dans le studio.',
  'adm.floor.studioBadge': 'STUDIO',
  'adm.floor.studioBadgeTitle': 'Studio activé : tous les services de l’étage y ont accès',
  'adm.floor.chicken': 'Poule de l’étage',
  'adm.floor.chickenTip': 'Une poule se promène entre les équipes. Décor seulement : aucun crédit, rien sur le serveur.',
  'adm.floor.chickenTipAria': 'À propos de la poule de l’étage',
  'adm.floor.cat': 'Chat de l’étage',
  'adm.floor.catTip': 'Un chat gris et blanc vit entre les équipes : il se promène, s’assoit, fait sa toilette et la sieste. Décor seulement : aucun crédit, rien sur le serveur.',
  'adm.floor.catTipAria': 'À propos du chat de l’étage',
  'adm.floor.create': 'CRÉER L’ÉTAGE',
  'adm.floor.created': 'Étage « {name} » créé.',
  // Données de l’étage (`dataFloor`): a floor that uses another floor's tables, notes and team.
  'adm.floor.data': 'Données de l’étage',
  'adm.floor.dataHint': 'Les Tables du bureau, les notes de l’étage et l’équipe (les agents qui se passent des tâches) sont celles de l’étage choisi, et son contexte du projet sert tant que celui-ci est vide. Le nom, les connecteurs autorisés, le studio et les accès des personnes restent ceux de cet étage.',
  'adm.floor.dataOwn': 'Les siennes',
  'adm.floor.dataIgnored': '« {name} » (ignoré : choisissez un autre étage)',
  'adm.floor.dataHost': {
    one: 'L’étage {list} utilise les données de cet étage : il garde les siennes.',
    other: 'Les étages {list} utilisent les données de cet étage : il garde les siennes.',
  },
  'adm.floor.dataBadge': 'DONNÉES DE « {name} »',
  'adm.floor.dataBadgeTitle': 'Utilise les Tables du bureau, les notes et l’équipe de l’étage « {name} »',
  'adm.floor.dataShares': 'Partage ses données avec : {list}',
  'adm.floor.dataClearTitle': 'Reprendre les données de l’étage « {name} » ?',
  'adm.floor.dataClearText': 'Ses agents n’utiliseront plus les Tables du bureau, les notes ni l’équipe de « {host} » : ils retrouveront les données de l’étage « {name} », vides. Rien n’est supprimé ni copié ; les données de « {host} » restent où elles sont.',
  'adm.floor.dataClearOk': 'REPRENDRE SES DONNÉES',
  'adm.floor.dataSwitchTitle': 'Changer les données de l’étage « {name} » ?',
  'adm.floor.dataSwitchText': 'Ses agents utiliseront les Tables du bureau, les notes et l’équipe de « {next} » au lieu de celles de « {host} ». Rien n’est supprimé ni copié.',
  'adm.floor.dataSwitchOk': 'CHANGER DE DONNÉES',
  'adm.dept.lead': '★ {name}',
  'adm.dept.noLead': 'Pas de responsable',
  'adm.dept.agents': { one: '{n} agent', other: '{n} agents' },
  'adm.dept.showAgents': 'Agents ({n})',
  'adm.dept.edit': 'Modifier le service « {name} »',
  'adm.dept.delete': 'Supprimer le service « {name} »',
  'adm.dept.deleteBlocked': 'Supprimez ou déplacez d’abord ses agents.',
  'adm.dept.deleteTitle': 'Supprimer le service « {name} » ?',
  'adm.dept.deleteText': 'Le service est vide : il disparaîtra de l’étage. Cette action est irréversible.',
  'adm.dept.deleted': 'Service « {name} » supprimé.',
  'adm.dept.createTitle': 'Nouveau service',
  'adm.dept.createSubtitle': 'Sur l’étage « {floor} »',
  'adm.dept.editTitle': 'Service « {name} »',
  'adm.dept.name': 'Nom',
  'adm.dept.namePlaceholder': 'ex. Service client',
  'adm.dept.color': 'Couleur',
  'adm.dept.context': 'Contexte du service',
  'adm.dept.contextHint': 'Lu par les agents du service avant chaque tâche : son rôle, ses habitudes, ses modèles.',
  'adm.dept.leadField': 'Responsable du service',
  'adm.dept.leadHint': 'Le responsable reçoit les tâches quand personne d’autre ne convient.',
  'adm.dept.leadNone': 'Ajoutez d’abord un agent.',
  'adm.dept.create': 'CRÉER LE SERVICE',
  'adm.dept.created': 'Service « {name} » créé.',
  // A whole department changing floor (POST /api/departments/:id/move).
  'adm.dept.move': 'Changer d’étage',
  'adm.dept.moveAria': 'Changer le service « {name} » d’étage',
  'adm.move.title': 'Changer le service « {name} » d’étage',
  'adm.move.subtitle': 'Aujourd’hui sur l’étage « {floor} »',
  'adm.move.text': 'Tout le service change d’étage : ses agents, ses routines, ses déclencheurs et ses tâches le suivent, et les accès des personnes sont mis à jour. Rien n’est fait avant votre confirmation.',
  'adm.move.floor': 'Nouvel étage',
  'adm.move.allowData': 'Changer de données',
  'adm.move.allowDataHint': 'Cet étage n’utilise pas les mêmes données : le service passera aux Tables du bureau, aux notes et à l’équipe du nouvel étage.',
  'adm.move.extendGrants': 'Garder les accès sur tout l’étage',
  'adm.move.extendGrantsHint': 'Une personne qui a un accès sur tout l’étage « {floor} » garde l’accès au service sur le nouvel étage. Décochez pour un retour en arrière : seuls les accès donnés sur le service le suivent.',
  'adm.move.check': 'VÉRIFIER ET DÉPLACER',
  'adm.move.blocked': 'Le service ne peut pas changer d’étage pour l’instant :',
  'adm.move.unchanged': 'Le service est déjà sur cet étage.',
  'adm.move.confirmTitle': 'Déplacer « {dept} » sur l’étage « {floor} » ?',
  'adm.move.ok': 'DÉPLACER',
  'adm.move.done': 'Service « {dept} » déplacé sur l’étage « {floor} ».',
  'adm.move.summary': 'Le service « {dept} » passe de l’étage « {from} » à « {to} » avec {what}.',
  'adm.move.agents': { one: '{n} agent', other: '{n} agents' },
  'adm.move.routines': { one: '{n} routine', other: '{n} routines' },
  'adm.move.triggers': { one: '{n} déclencheur', other: '{n} déclencheurs' },
  'adm.move.tasks': { one: '{n} tâche de son historique', other: '{n} tâches de son historique' },
  'adm.move.and': 'et',
  'adm.move.automations': 'Routines et déclencheurs gardent leur auteur, leurs horaires et leur état (en pause ou non).',
  'adm.move.grants': 'Accès mis à jour pour : {list}.',
  'adm.move.noGrants': 'Aucun accès de personne à mettre à jour.',
  'adm.move.warnings': 'À savoir : {list}.',
  'adm.agent.new': 'NOUVEL AGENT',
  'adm.agent.settings': 'RÉGLAGES',
  'adm.agent.settingsAria': 'Réglages de {name}',
  'adm.agent.none': 'Aucun agent dans ce service.',
  'adm.agent.createTitle': 'Nouvel agent',
  'adm.agent.createSubtitle': 'Service « {dept} » · étage « {floor} »',
  'adm.agent.name': 'Nom',
  'adm.agent.orderHint': 'Cet ordre est celui des bureaux sur le plan du bureau et des listes. Le responsable ★ reste en tête : il a le bureau face à l’équipe.',
  'adm.agent.leadFirst': 'Le responsable reste en tête',
  'adm.agent.nameHint': 'En majuscules, 22 caractères maximum : c’est l’étiquette sur son bureau.',
  'adm.agent.role': 'Rôle',
  'adm.agent.rolePlaceholder': 'ex. Rédacteur de newsletters',
  'adm.agent.does': 'Ce qu’il fait',
  'adm.agent.doesHint': 'Une ou deux phrases : l’agent les lit avant chaque tâche, et le service s’en sert pour choisir qui travaille.',
  'adm.agent.engine': 'Moteur',
  'adm.agent.engine.claude': 'Claude',
  'adm.agent.engine.codex': 'Codex (ChatGPT)',
  'adm.agent.engine.openai-image': 'Images OpenAI',
  'adm.agent.engine.gemini': 'Gemini (analyse de vidéos et d’images ; pas d’outils)',
  'adm.agent.engine.kie': 'Kie.ai (vidéo à partir d’une image)',
  'adm.agent.create': 'CRÉER L’AGENT',
  'adm.agent.created': 'Agent {name} créé.',
  'adm.agent.openSettings': 'Réglages',
  'adm.color.coral': 'Corail',
  'adm.color.teal': 'Turquoise',
  'adm.color.sky': 'Ciel',
  'adm.color.sand': 'Sable',
  'adm.color.lavender': 'Lavande',
  'adm.color.periwinkle': 'Pervenche',
  'adm.color.sage': 'Sauge',
  'adm.color.peach': 'Pêche',
  'adm.color.custom': 'Couleur personnalisée ({hex})',

  // Connectors
  'adm.conn.title': 'Connecteurs',
  'adm.conn.intro': 'Les services dont vos agents peuvent se servir, et ce qu’ils ont le droit d’y faire.',
  'adm.conn.introTip': 'Certains sont branchés dans Claude Code ou Codex sur le serveur. Les autres sont ajoutés ici et servent sur tous les étages. Ce que chaque agent peut en faire se règle dans ses réglages.',
  'adm.conn.refresh': 'ACTUALISER',
  'adm.conn.add': 'AJOUTER UN CONNECTEUR',
  'adm.conn.library': 'AJOUTÉ',
  'adm.conn.needsFolder': 'dossier à choisir',
  'adm.conn.libraryHint': 'Ajouté dans le bureau (bibliothèque de connecteurs) : sur tous les étages, pour les agents Claude et Codex.',
  'adm.shopify.title': 'Application Shopify',
  'adm.shopify.ready': 'PRÊTE',
  'adm.shopify.notReady': 'À RÉGLER',
  'adm.shopify.optional': 'FACULTATIVE',
  'adm.shopify.intro': 'Facultative. Sans elle, « Se connecter avec Shopify » passe par la CLI Shopify du serveur : aucune application à créer, mais une reconnexion parfois quotidienne et 60 jours de commandes au plus. Avec une application Shopify à vous, réglée une fois ici, les connexions durent, l’historique complet des commandes est possible et chacun choisit la boutique dans Shopify. Chacun ajoute ensuite ses boutiques en un clic (connecteur Shopify), autant de fois que nécessaire.',
  'adm.shopify.introNoCli': 'Sans elle ni la CLI Shopify (pas installée sur ce serveur), seul un jeton d’accès collé à la main connecte une boutique, et Shopify n’en crée plus pour les nouvelles boutiques. Avec une application Shopify à vous, réglée une fois ici, chacun « Se connecte avec Shopify » et choisit la boutique dans Shopify ; les connexions durent et l’historique complet des commandes est possible. Chacun ajoute ensuite ses boutiques en un clic (connecteur Shopify), autant de fois que nécessaire.',
  'adm.shopify.step1': 'Dans le Dev Dashboard de Shopify (dev.shopify.com → Apps → « Create app »), créez l’application dans l’organisation qui possède vos boutiques.',
  'adm.shopify.step2': 'Dans sa version (« Versions » → « Create a version »), mettez cette adresse dans « App URL », exactement, et décochez « Embed app in Shopify admin » :',
  'adm.shopify.step3': 'Toujours dans la version, ajoutez cette adresse dans « Redirect URLs », exactement :',
  'adm.shopify.step4': 'Dans « Scopes », mettez les autorisations enregistrées ici (les mêmes que le champ ci-dessous), puis « Release » pour publier la version.',
  'adm.shopify.step5': 'Copiez ici le Client ID et le Secret de l’application (« Settings »), et, si vous voulez, l’adresse de l’application dans le Dev Dashboard (celle de la barre d’adresse) : « Se connecter avec Shopify » ouvrira alors directement son installation, où l’on choisit la boutique. Enregistrez.',
  'adm.shopify.installLink': 'Adresse de l’application dans le Dev Dashboard, ou lien d’installation',
  'adm.shopify.installLinkHint': 'Ex. https://dev.shopify.com/dashboard/1234567/apps/…, ou le lien d’installation d’une distribution personnalisée (https://admin.shopify.com/oauth/install_custom_app?…). Vide : Shopify demande la boutique sur sa propre page d’installation.',
  'adm.shopify.start.install': 'Sans adresse de boutique, « Se connecter avec Shopify » ouvre votre lien d’installation.',
  'adm.shopify.start.organization': 'Sans adresse de boutique, « Se connecter avec Shopify » ouvre l’installation de l’application dans le Dev Dashboard (organisation {id}).',
  'adm.shopify.start.default': 'Sans adresse de boutique, « Se connecter avec Shopify » ouvre la page d’installation de Shopify, qui demande la boutique.',
  'adm.shopify.clientId': 'Client ID',
  'adm.shopify.clientSecret': 'Secret de l’application',
  'adm.shopify.secretHint': 'Gardé sur le serveur du bureau ; seuls ses 4 derniers caractères seront affichés.',
  'adm.shopify.secretKeep': 'Enregistré ({hint}) : laissez vide pour le garder.',
  'adm.shopify.scopes': 'Autorisations demandées (scopes)',
  'adm.shopify.scopesHint': 'Séparées par des virgules. Par défaut : lecture et écriture des produits, commandes, clients et stocks.',
  'adm.shopify.apiVersion': 'Version de l’API Admin',
  'adm.shopify.save': 'ENREGISTRER',
  'adm.shopify.saved': 'Application Shopify enregistrée : « Se connecter avec Shopify » est disponible.',
  'adm.shopify.clear': 'Effacer',
  'adm.shopify.clearTitle': 'Effacer l’application Shopify ?',
  'adm.shopify.clearText': 'Plus personne ne pourra « Se connecter avec Shopify » par cette application (la CLI Shopify du serveur prend le relais si elle est installée). Les boutiques connectées par cette application perdent leur accès quand leur jeton prend fin, en général dans l’heure (le bureau ne peut plus le renouveler) : elles passent « à reconnecter », par la CLI Shopify ou un jeton collé. Les boutiques connectées par la CLI ou par un jeton collé ne changent pas.',
  'adm.shopify.cleared': 'Application Shopify effacée.',
  'adm.shopify.note': 'Une boutique s’installe aussi depuis le Dev Dashboard (« Install app », choix de la boutique) : le bureau demande alors à quel connecteur la relier. Sans application réglée ici, « Se connecter avec Shopify » passe par la CLI Shopify du serveur quand elle y est installée ; une boutique qui a encore un jeton permanent shpat_… (application créée autrefois dans son admin) peut aussi coller ce jeton.',
  // Application Google (admin/drive.js): the office's Google app behind every Google Drive connector
  // of the library — a stepper in Google Cloud (the why in « ? » tooltips), then the form —, the
  // connectors and the one storing the office's files, the server's disk.
  'adm.drive.title': 'Application Google',
  'adm.drive.ready': 'PRÊTE',
  'adm.drive.notReady': 'À RÉGLER',
  'adm.drive.noKey': 'CLÉ API MANQUANTE',
  'adm.drive.count': '{n} Google Drive',
  'adm.drive.countOn': { one: '{n} connecté', other: '{n} connectés' },
  'adm.drive.countNone': 'à connecter',
  'adm.drive.lead': 'À régler une seule fois. Elle permet de connecter des Google Drive au bureau.',
  'adm.drive.leadTip': 'Une même application peut servir plusieurs bureaux. Chaque Google Drive se connecte ensuite avec son propre compte Google.',
  'adm.drive.tipAria': 'En savoir plus : {name}',
  'adm.drive.disk': 'Disque du serveur : {used} utilisés sur {total} ({free} libres)',
  'adm.drive.diskAria': 'Disque du serveur rempli à {pct} %',
  'adm.drive.otherOrigin': 'Google renverra vers {there}. Ouvrez le bureau à cette adresse pour connecter un Google Drive.',
  'adm.drive.otherOriginTip': 'Vous êtes sur {here}. La connexion s’y perdrait.',
  'adm.drive.step1': 'Créer un projet Google Cloud',
  'adm.drive.step1Text': 'Donnez-lui un nom, par exemple Maeck Office.',
  'adm.drive.step1Tip': 'Vous avez déjà un projet pour un autre bureau ? Reprenez-le.',
  'adm.drive.step1Link': 'Ouvrir Google Cloud',
  'adm.drive.step2': 'Activer deux services Google',
  'adm.drive.step2Tip': 'Google Drive API sert à lire et ranger les fichiers. Google Picker API est la fenêtre Google où vous choisissez le dossier. C’est elle qui limite le bureau à ce dossier.',
  'adm.drive.step2Drive': 'Activer Google Drive API',
  'adm.drive.step2Picker': 'Activer Google Picker API',
  'adm.drive.step3': 'Présenter l’application',
  'adm.drive.step3Text': 'Cliquez sur « Commencer ». Donnez un nom et votre e-mail. Choisissez « Externe ».',
  'adm.drive.step3Paste': 'Ensuite, dans « Branding », collez ces trois adresses.',
  'adm.drive.step3Tip': 'N’ajoutez pas de logo. Google demanderait une vérification de plusieurs semaines.',
  'adm.drive.step3Link': 'Ouvrir Branding',
  'adm.drive.home': 'Page d’accueil',
  'adm.drive.privacy': 'Règles de confidentialité',
  'adm.drive.domain': 'Domaine autorisé',
  'adm.drive.domainNone': 'Le bureau doit avoir un nom de domaine. Google refuse une adresse IP ou localhost.',
  'adm.drive.step4': 'Ouvrir l’application à tous',
  'adm.drive.step4Text': 'Cliquez sur « Publier l’application », puis confirmez.',
  'adm.drive.step4Scope': 'Dans « Accès aux données », cliquez sur « Ajouter ou supprimer des champs d’application ». Collez cette adresse, puis enregistrez.',
  'adm.drive.step4Tip': 'Sans publication, Google coupe la connexion au bout de 7 jours. Un Google Drive en « Tout le Drive » demande aussi https://www.googleapis.com/auth/drive.',
  'adm.drive.scope': 'Champ d’application',
  'adm.drive.step4Audience': 'Ouvrir Audience',
  'adm.drive.step4Scopes': 'Ouvrir Accès aux données',
  'adm.drive.step5': 'Créer l’identifiant de connexion',
  'adm.drive.step5Text': 'Cliquez sur « Créer un client », puis choisissez « Application Web ». Dans « URI de redirection autorisés », ajoutez cette adresse :',
  'adm.drive.step5Secret': 'Google n’affiche le code secret qu’une seule fois. Copiez-le tout de suite avec le Client ID.',
  'adm.drive.step5Tip': 'Après la connexion d’un compte, Google revient au bureau par cette adresse. Collez-la à l’identique.',
  'adm.drive.step5Agent': 'Ne cochez pas « Use this client for an AI-powered agent ».',
  'adm.drive.step5Link': 'Ouvrir Clients',
  'adm.drive.redirect': 'Adresse de redirection',
  'adm.drive.step6': 'Créer la clé API',
  'adm.drive.step6Text': 'Cliquez sur « Créer des identifiants », puis « Clé API ». Autorisez seulement ce site :',
  'adm.drive.step6Tip': 'La clé sert seulement à ouvrir la fenêtre Google « Choisir un dossier ». Dans « Restrictions relatives aux applications », choisissez « Sites Web » et collez l’adresse. Dans « Restrictions relatives aux API », cochez « Google Picker API ».',
  'adm.drive.step6Link': 'Ouvrir Identifiants',
  'adm.drive.site': 'Site autorisé',
  'adm.drive.step7': 'Coller les trois codes',
  'adm.drive.step7Tip': 'Ces codes restent sur le serveur du bureau. Le secret et la clé ne sont jamais réaffichés.',
  'adm.drive.clientId': 'Client ID',
  'adm.drive.clientIdTip': 'Dans « Clients », ouvrez le client créé à l’étape 5.',
  'adm.drive.clientSecret': 'Code secret du client',
  'adm.drive.clientSecretTip': 'Il s’affiche une seule fois, à la création du client. Sinon, ajoutez un nouveau secret dans le client.',
  'adm.drive.apiKey': 'Clé API',
  'adm.drive.apiKeyTip': 'Dans « Identifiants », section « Clés API ». C’est la clé de l’étape 6.',
  'adm.drive.secretKeep': 'Enregistré ({hint}). Laissez vide pour le garder.',
  'adm.drive.apiKeyKeep': 'Enregistrée ({hint}). Laissez vide pour la garder.',
  'adm.drive.number': 'Numéro du projet : {n} (lu dans le Client ID)',
  'adm.drive.numberSaved': 'Numéro du projet : {n}',
  'adm.drive.save': 'ENREGISTRER',
  'adm.drive.saved': 'Application Google enregistrée. Ajoutez maintenant un Google Drive.',
  'adm.drive.readyTitle': 'Application Google prête',
  'adm.drive.readyClient': 'Client ID {hint}',
  'adm.drive.readyKey': 'Clé API {hint}',
  'adm.drive.readyNumber': 'Numéro du projet {n}',
  'adm.drive.noKeyTitle': 'Il manque la clé API',
  'adm.drive.noKeyText': 'Sans elle, personne ne peut choisir le dossier d’un Google Drive.',
  'adm.drive.addKey': 'AJOUTER LA CLÉ API',
  'adm.drive.noKeyConfirmTitle': 'Enregistrer sans clé API ?',
  'adm.drive.noKeyConfirmText': 'Sans clé API, personne ne pourra choisir le dossier d’un Google Drive. Vous pourrez l’ajouter plus tard.',
  'adm.drive.noKeyConfirmOk': 'ENREGISTRER SANS CLÉ',
  'adm.drive.edit': 'Modifier',
  'adm.drive.changeTitle': 'Changer d’application Google ?',
  'adm.drive.changeText': {
    one: 'Le Google Drive connecté sera déconnecté. Il devra se reconnecter. En accès limité, il ne verra plus les fichiers envoyés avec l’ancienne application.',
    other: 'Les {n} Google Drive connectés seront déconnectés. Ils devront se reconnecter. En accès limité, ils ne verront plus les fichiers envoyés avec l’ancienne application.',
  },
  'adm.drive.changeOk': 'CHANGER',
  'adm.drive.connectorsCleared': {
    one: 'Nouvelle application Google. {n} Google Drive a été déconnecté. Reconnectez-le.',
    other: 'Nouvelle application Google. {n} Google Drive ont été déconnectés. Reconnectez-les.',
  },
  'adm.drive.clear': 'Retirer',
  'adm.drive.clearTitle': 'Retirer l’application Google du bureau ?',
  'adm.drive.clearText': 'Chaque Google Drive sera déconnecté du bureau, pas chez Google. Les fichiers déjà envoyés restent dans Google Drive. Les nouveaux fichiers resteront sur le serveur.',
  'adm.drive.cleared': 'Application Google retirée du bureau.',
  'adm.drive.connectorsDisconnected': { one: '{n} Google Drive a été déconnecté.', other: '{n} Google Drive ont été déconnectés.' },
  'adm.drive.connectors': 'Vos Google Drive',
  'adm.drive.connectorsTip': 'Chacun a son compte Google et son dossier. Qui peut s’en servir se règle dans les « Connecteurs autorisés » de chaque personne.',
  'adm.drive.noConnectors': 'Aucun Google Drive pour l’instant.',
  'adm.drive.storageBadge': 'FICHIERS DU BUREAU',
  'adm.drive.storageName': 'Fichiers du bureau',
  'adm.drive.storageNone': 'Les fichiers du bureau restent sur le serveur.',
  'adm.drive.storageTip': 'Ce sont les fichiers du Studio et des tâches. Pour libérer le serveur, ouvrez les RÉGLAGES d’un Google Drive, puis « Stocker les fichiers du bureau ici ».',
  'adm.drive.add': 'AJOUTER UN GOOGLE DRIVE',
  'adm.drive.appFirst': 'Réglez d’abord l’application Google.',
  'adm.drive.settings': 'RÉGLAGES',
  'adm.drive.rowConnect': 'SE CONNECTER',
  'adm.drive.rowReconnect': 'RECONNECTER',
  'adm.drive.rowPick': 'CHOISIR LE DOSSIER',
  'adm.drive.settingsAria': 'Réglages de « {name} »',
  'adm.drive.libraryOff': 'La bibliothèque de connecteurs est désactivée sur ce serveur. Sans elle, aucun Google Drive ne s’ajoute.',
  'adm.conn.everyFloor': 'Sur tous les étages (ajouté dans le bureau) : il suffit de le donner à un agent dans ses réglages.',
  'adm.conn.libraryNoTools': 'Ses outils seront listés une fois connecté.',
  'adm.conn.probing': 'Détection en cours…',
  'adm.conn.probingHint': 'Claude Code démarre sur le serveur du bureau et liste ses connecteurs : cela peut prendre une minute.',
  'adm.conn.probedAt': 'Dernière détection {when}',
  'adm.conn.neverProbed': 'Jamais détectés : cliquez sur ACTUALISER.',
  'adm.conn.lastError': 'La dernière détection a échoué : {error}',
  'adm.conn.refreshed': { one: '{n} connecteur détecté.', other: '{n} connecteurs détectés.' },
  'adm.conn.count': { one: '{n} connecteur', other: '{n} connecteurs' },
  'adm.conn.empty.title': 'Aucun connecteur',
  'adm.conn.empty.text': 'Ajoutez-en un ici (AJOUTER UN CONNECTEUR : Canva ou une adresse MCP), ou sur claude.ai (ou avec claude mcp add… sur le serveur du bureau) puis ACTUALISER.',
  'adm.conn.empty.textNoLibrary': 'Ajoutez des connecteurs sur claude.ai (ou avec claude mcp add… sur le serveur du bureau), puis ACTUALISER.',
  'adm.conn.unavailable': 'La gestion des connecteurs n’est pas encore disponible sur ce serveur.',
  'adm.conn.mock': 'Mode simulation : ce catalogue est fictif. Les vrais connecteurs apparaîtront une fois le bureau lancé sans OFFICE_ENGINE=mock.',
  'adm.conn.explain.title': 'Lecture ou écriture ?',
  'adm.conn.explain.read': 'Lecture : l’outil consulte (lister, chercher, lire, télécharger). Les agents peuvent s’en servir à tout moment, même pour préparer un brouillon.',
  'adm.conn.explain.write': 'Écriture : l’outil agit (envoie, publie, crée, modifie, supprime, paie). Un agent ne s’en sert qu’une fois la tâche validée par vous, ou seul si la tâche est en mode automatique, et seulement s’il a l’accès « écriture » à ce connecteur.',
  'adm.conn.explain.auto': 'Le classement est automatique d’après le nom de l’outil. Corrigez-le ici quand il se trompe : dans le doute, laissez « Écriture ».',
  'adm.conn.engine.claude': 'CLAUDE',
  'adm.conn.engine.codex': 'CODEX',
  'adm.conn.tools': { one: '{n} outil', other: '{n} outils' },
  'adm.conn.split': '{read} en lecture · {write} en écriture',
  'adm.conn.allowedOn': 'Autorisé sur : {list}',
  'adm.conn.allowedNowhere': 'Autorisé sur aucun étage (à régler dans « Étages & services »).',
  'adm.conn.showTools': 'Voir les outils ({n})',
  'adm.conn.hideTools': 'Masquer les outils',
  'adm.conn.noTools': 'Aucun outil listé pour ce connecteur.',
  'adm.conn.codexTools': 'Codex ne détaille pas ses outils : l’accès se règle connecteur par connecteur, dans les réglages de l’agent.',
  'adm.conn.filter': 'Filtrer les outils',
  'adm.conn.noMatch': 'Aucun outil ne correspond.',
  'adm.conn.kind.read': 'Lecture',
  'adm.conn.kind.write': 'Écriture',
  'adm.conn.kindAria': 'Classement de l’outil {name}',
  'adm.conn.manual': 'MANUEL',
  'adm.conn.manualHint': 'Classement choisi à la main',
  'adm.conn.reset': 'Automatique',
  'adm.conn.resetAria': 'Revenir au classement automatique pour {name}',
  'adm.conn.overrideSaved': '« {name} » : {kind}.',
  'adm.conn.overrideReset': '« {name} » : classement automatique.',

  // Engines
  'adm.eng.title': 'Moteurs',
  'adm.eng.intro': 'Les IA que les agents font tourner sur le serveur du bureau. Vérifiez ici qu’elles sont installées et connectées.',
  'adm.eng.hosted': 'Instance en ligne : Claude Code, Codex et Gemini sont déjà installés. Connectez les comptes ci-dessus ; pour les images OpenAI facturées à l’unité, ajoutez la variable OPENAI_API_KEY dans Railway.',
  'adm.eng.refresh': 'VÉRIFIER À NOUVEAU',
  'adm.eng.checkedAt': 'Vérifié {when}',
  'adm.eng.mockForced': 'Mode simulation forcé (OFFICE_ENGINE=mock) : tous les agents utilisent le moteur factice. Aucun appel IA, aucun coût, mais aucun vrai travail non plus.',
  'adm.eng.state.ok': 'CONNECTÉ',
  'adm.eng.state.error': 'INDISPONIBLE',
  'adm.eng.state.disconnected': 'NON CONNECTÉ',
  'adm.eng.state.unchecked': 'NON VÉRIFIÉ',
  'adm.eng.state.disabled': 'DÉSACTIVÉ',
  'adm.eng.state.pending': 'VÉRIFICATION…',
  'adm.eng.state.mock': 'SIMULÉ',
  'adm.eng.state.unknown': 'INCONNU',
  'adm.eng.version': 'Version',
  'adm.eng.model': 'Modèle',
  'adm.eng.error': 'Problème',
  'adm.eng.howto': 'Installer, connecter, dépanner',
  'adm.eng.unavailable': 'L’état des moteurs n’est pas encore disponible sur ce serveur : affichage des dernières informations connues.',
  'adm.eng.name.claude': 'Claude Code',
  'adm.eng.name.codex': 'Codex (ChatGPT)',
  'adm.eng.name.openai-image': 'Images OpenAI',
  'adm.eng.name.gemini': 'Gemini',
  'adm.eng.name.kie': 'Kie.ai (génération de vidéos)',
  'adm.eng.name.mock': 'Simulation',
  'adm.eng.desc.gemini': 'Facultatif : Gemini (Google) pour analyser des vidéos, des images, des PDF ou de l’audio. Par l’API avec une clé GEMINI_API_KEY (recommandé, la seule voie pour la vidéo), sinon par le CLI gemini.',
  'adm.eng.mode': 'Mode',
  'adm.eng.mode.api': 'API (clé GEMINI_API_KEY)',
  'adm.eng.mode.cli': 'CLI gemini (pas de vidéo)',
  'adm.eng.hint.gemini.key': 'Créez une clé sur Google AI Studio et écrivez GEMINI_API_KEY=… dans le fichier privé config/.env du bureau :',
  'adm.eng.hint.gemini.enable': 'Relancez l’installation pour que le service reçoive la variable (le moteur est activé par défaut, section engines.gemini de config/office.json) :',
  'adm.eng.hint.gemini.cli': 'Sans clé, le bureau se rabat sur le CLI gemini s’il est installé (texte, images, PDF, audio ; pas de vidéo) :',
  'adm.eng.desc.claude': 'Le moteur principal : les agents lancent Claude Code sur le serveur du bureau, avec votre abonnement Claude et vos connecteurs.',
  'adm.eng.desc.codex': 'Facultatif : Codex, sur votre abonnement ChatGPT, surtout pour créer des images.',
  'adm.eng.desc.openai-image': 'Facultatif et payant à l’image : l’API OpenAI Images, avec une clé OPENAI_API_KEY.',
  'adm.eng.desc.kie': 'Facultatif et payant en crédits Kie.ai : des vidéos à partir des fichiers joints (image de départ, références, vidéo de mouvement, voix) et d’une description. Seedance de ByteDance par défaut ; MiniMax H3, Kling 3.0, Wan, InfiniTalk et Topaz au choix (modèle de l’agent) ; Suno V6 (suno/v6) pour une musique (MP3). Actif dès qu’une clé est enregistrée.',
  'adm.eng.hint.kie.key': 'Créez une clé sur kie.ai (API Key), puis collez-la dans la carte Kie.ai de « Connexion des comptes » ci-dessus (ou variable KIE_API_KEY dans config/.env).',
  'adm.eng.hint.kie.public': 'Kie.ai télécharge les fichiers joints (images, vidéos, sons) par des liens signés vers le bureau : l’adresse publique du bureau (OFFICE_PUBLIC_URL) doit être en https:// et joignable depuis Internet.',
  'adm.eng.desc.mock': 'Un moteur factice pour les essais et les démonstrations : aucune IA, aucun coût.',
  'adm.eng.mockOn': 'Forcé : OFFICE_ENGINE=mock est défini.',
  'adm.eng.mockOff': 'Inactif : les agents utilisent leurs vrais moteurs.',
  'adm.eng.step.install': 'Installer',
  'adm.eng.step.login': 'Se connecter',
  'adm.eng.step.check': 'Vérifier',
  'adm.eng.step.enable': 'Activer',
  'adm.eng.hint.claude.login': 'Lancez claude, tapez /login, choisissez votre compte Claude (abonnement), validez dans le navigateur, puis /exit.',
  'adm.eng.hint.claude.check': 'La deuxième commande liste les connecteurs que les agents pourront utiliser.',
  'adm.eng.hint.codex.login': 'Sans navigateur sur le Mac mini : codex login --device-auth.',
  'adm.eng.hint.openai.key': 'Écrivez OPENAI_API_KEY=sk-… dans le fichier privé config/.env du bureau :',
  'adm.eng.hint.openai.enable': 'Passez "enabled": true dans la section engines.openaiImages de config/office.json, puis relancez l’installation :',
  'adm.eng.hint.mock': 'Pour travailler pour de vrai, démarrez le bureau sans OFFICE_ENGINE=mock (npm start plutôt que npm run dev).',
  'adm.eng.hint.doc': 'Guide complet : docs/DEPLOY-MACMINI.md, section 4.',

  // Engines → Connexion des comptes (web/ui/admin/accounts.js)
  'adm.acc.title': 'Connexion des comptes',
  'adm.acc.intro': 'Les comptes avec lesquels les agents travaillent : votre abonnement Claude (et vos connecteurs claude.ai), votre abonnement ChatGPT pour Codex, une clé Gemini, une clé Kie.ai pour les vidéos. Si une connexion expire, refaites-la ici.',
  'adm.acc.unavailable': 'La connexion des comptes depuis le bureau n’est pas encore disponible sur ce serveur.',
  'adm.acc.loadError': 'État des comptes illisible : {error}',
  'adm.acc.mock': 'Mode simulé : pas de connexion réelle.',
  'adm.acc.introLocal': 'Les comptes avec lesquels les agents travaillent : votre abonnement Claude (et vos connecteurs claude.ai), votre abonnement ChatGPT pour Codex, une clé Gemini, une clé Kie.ai pour les vidéos. Sur ce serveur, Claude et ChatGPT se connectent dans le Terminal ; les clés Gemini et Kie.ai se règlent ici.',
  'adm.acc.local': 'Sur ce serveur, les connexions Claude et ChatGPT se font dans le Terminal (réglage engineLogins désactivé) : suivez la procédure ci-dessous.',
  'adm.acc.name.claude': 'Claude',
  'adm.acc.name.codex': 'ChatGPT (Codex)',
  'adm.acc.name.gemini': 'Gemini',
  'adm.acc.name.kie': 'Kie.ai (vidéo)',
  'adm.acc.badge.claude.account': 'CONNECTÉ',
  'adm.acc.badge.claude.token': 'JETON LIMITÉ',
  'adm.acc.badge.claude.none': 'NON CONNECTÉ',
  'adm.acc.badge.claude.unknown': 'INCONNU',
  'adm.acc.badge.claude.error': 'ERREUR',
  'adm.acc.badge.codex.chatgpt': 'CONNECTÉ',
  'adm.acc.badge.codex.apikey': 'CLÉ API',
  'adm.acc.badge.codex.none': 'NON CONNECTÉ',
  'adm.acc.badge.codex.unknown': 'INCONNU',
  'adm.acc.badge.codex.error': 'ERREUR',
  'adm.acc.badge.kie.stored': 'CLÉ ENREGISTRÉE',
  'adm.acc.badge.kie.env': 'CLÉ EN VARIABLE',
  'adm.acc.badge.kie.none': 'PAS DE CLÉ',
  'adm.acc.badge.kie.unknown': 'INCONNU',
  'adm.acc.badge.gemini.stored': 'CLÉ ENREGISTRÉE',
  'adm.acc.badge.gemini.env': 'CLÉ EN VARIABLE',
  'adm.acc.badge.gemini.none': 'PAS DE CLÉ',
  'adm.acc.badge.gemini.unknown': 'INCONNU',
  'adm.acc.claude.account': 'Compte Claude connecté',
  'adm.acc.claude.token': 'Jeton limité : pas de connecteurs',
  'adm.acc.claude.none': 'Non connecté',
  'adm.acc.claude.unknown': 'État inconnu',
  'adm.acc.claude.error': 'État illisible',
  'adm.acc.codex.chatgpt': 'Compte ChatGPT connecté',
  'adm.acc.codex.apikey': 'Connecté par une clé API OpenAI (payée à l’usage, hors abonnement ChatGPT)',
  'adm.acc.codex.apikeyVar': 'Clé API OpenAI de la variable CODEX_API_KEY (payée à l’usage, hors abonnement ChatGPT) : sa validité est vérifiée dans la carte Codex ci-dessous',
  'adm.acc.codex.none': 'Non connecté',
  'adm.acc.codex.unknown': 'État inconnu',
  'adm.acc.codex.error': 'État illisible',
  'adm.acc.claude.tokenVar': 'La variable CLAUDE_CODE_OAUTH_TOKEN est définie dans Railway : elle passe avant votre compte et masque vos connecteurs. Supprimez-la (Railway → Variables), puis reconnectez-vous.',
  'adm.acc.claude.tokenVarLocal': 'La variable CLAUDE_CODE_OAUTH_TOKEN est définie dans l’environnement du bureau : elle passe avant votre compte et masque vos connecteurs. Retirez-la (fichier config/.env), relancez le bureau, puis vérifiez à nouveau.',
  'adm.acc.renew.in': { one: 'À renouveler dans {n} jour', other: 'À renouveler dans {n} jours' },
  'adm.acc.renew.today': 'À renouveler aujourd’hui',
  'adm.acc.renew.expired': 'Connexion expirée',
  'adm.acc.renew.hint': 'Cliquez sur « Reconnecter » pour prolonger la connexion de Claude.',
  'adm.acc.renew.hintLocal': 'Reconnectez-vous dans le Terminal de ce serveur (claude, puis /login).',
  'adm.acc.jobActive': 'Une connexion est en cours.',
  'adm.acc.claude.connect': 'Connecter mon compte Claude',
  'adm.acc.codex.connect': 'Connecter mon compte ChatGPT',
  'adm.acc.reconnect': 'Reconnecter',
  'adm.acc.resume': 'Reprendre la connexion',
  'adm.acc.reconnectAria': 'Reconnecter le compte {name}',
  'adm.acc.resumeAria': 'Reprendre la connexion du compte {name}',
  'adm.acc.logout': 'Se déconnecter',
  'adm.acc.logoutAria': 'Se déconnecter du compte {name}',
  'adm.acc.logoutTitle': 'Déconnecter le compte {name} ?',
  'adm.acc.logoutText.claude': 'Les agents qui utilisent Claude ne pourront plus travailler, et vos connecteurs claude.ai ne seront plus accessibles, jusqu’à la prochaine connexion.',
  'adm.acc.logoutText.codex': 'Les agents qui utilisent Codex ne pourront plus travailler jusqu’à la prochaine connexion.',
  'adm.acc.logoutDone': 'Compte {name} déconnecté.',
  'adm.acc.newTab': '(nouvel onglet)',
  'adm.acc.badUrl': 'Adresse de connexion inattendue : fermez cette fenêtre et recommencez.',
  'adm.acc.retry': 'Recommencer',
  'adm.acc.job.starting': 'Préparation de la connexion…',
  'adm.acc.job.waitingUser': 'En attente de votre autorisation sur la page OpenAI…',
  'adm.acc.job.checking.claude': 'Vérification du code…',
  'adm.acc.job.checking.codex': 'Vérification de la connexion…',
  'adm.acc.job.done.claude': 'Compte Claude connecté.',
  'adm.acc.job.done.codex': 'Compte ChatGPT connecté.',
  'adm.acc.job.error': 'La connexion a échoué.',
  'adm.acc.job.expired': 'Délai dépassé : la connexion a été abandonnée.',
  'adm.acc.job.cancelled': 'Connexion annulée.',
  'adm.acc.job.lost': 'Le serveur ne suit plus cette connexion (redémarrage ?) : recommencez.',
  'adm.acc.job.noJob': 'Le serveur n’a pas démarré la connexion : recommencez.',
  'adm.acc.claude.title': 'Connecter votre compte Claude',
  'adm.acc.claude.subtitle': 'Votre abonnement et vos connecteurs claude.ai, pour tous les agents.',
  'adm.acc.claude.step1': 'Autorisez le bureau sur le site de Claude',
  'adm.acc.claude.step1Hint': 'Un nouvel onglet s’ouvre : connectez-vous avec le compte qui a l’abonnement, puis cliquez sur « Autoriser ».',
  'adm.acc.claude.openPage': 'Ouvrir la page de connexion Claude',
  'adm.acc.claude.step2': 'Recopiez le code',
  'adm.acc.claude.codeLabel': 'Collez ici le code affiché par Claude',
  'adm.acc.claude.codeHint': 'Copiez le code en entier sur la page de Claude, puis revenez ici.',
  'adm.acc.claude.submit': 'Valider',
  'adm.acc.claude.why': 'Pourquoi un code : Claude ne renvoie pas directement vers votre bureau ; le code prouve que c’est bien vous qui avez autorisé la connexion. C’est l’outil officiel Claude Code, sur votre serveur, qui la termine.',
  'adm.acc.claude.connectorsHint': 'Vos connecteurs claude.ai sont maintenant accessibles aux agents : actualisez-les pour les voir dans « Connecteurs ».',
  'adm.acc.claude.refreshConnectors': 'Actualiser les connecteurs',
  'adm.acc.codex.title': 'Connecter votre compte ChatGPT',
  'adm.acc.codex.subtitle': 'Pour les agents qui utilisent Codex, sur votre abonnement ChatGPT.',
  'adm.acc.codex.step1': 'Copiez ce code',
  'adm.acc.codex.codeAria': 'Code à saisir sur la page OpenAI',
  'adm.acc.codex.countdown': 'Code valable encore {time}',
  'adm.acc.codex.codeExpired': 'Ce code a expiré.',
  'adm.acc.codex.step2': 'Saisissez-le sur la page OpenAI',
  'adm.acc.codex.step2Hint': 'Connectez-vous à ChatGPT dans le nouvel onglet, puis collez le code.',
  'adm.acc.codex.openPage': 'Ouvrir la page OpenAI',
  'adm.acc.codex.auto': 'C’est tout : le bureau détecte la connexion tout seul.',
  'adm.acc.codex.refused': 'Si OpenAI refuse le code : ChatGPT → Réglages → Sécurité → autoriser la connexion par code. Sur un compte d’entreprise ou d’équipe, c’est l’administrateur de l’espace qui l’autorise.',
  'adm.acc.code.required': 'Collez le code affiché par Claude.',
  'adm.acc.code.tooLong': 'Code trop long ({max} caractères maximum).',
  'adm.acc.code.oneLine': 'Le code tient sur une seule ligne : recopiez-le depuis la page de Claude.',
  'adm.acc.kie.stored': 'Clé enregistrée {hint}',
  'adm.acc.kie.env': 'Clé définie dans Railway ({env})',
  'adm.acc.kie.envLocal': 'Clé définie dans l’environnement du bureau ({env})',
  'adm.acc.kie.none': 'Pas de clé : le moteur Kie.ai (vidéo) est inactif',
  'adm.acc.kie.unknown': 'État inconnu',
  'adm.acc.kie.envHint': 'Elle passe avant une clé enregistrée ici. Pour la changer ou la retirer : Railway → Variables.',
  'adm.acc.kie.envHintLocal': 'Elle passe avant une clé enregistrée ici. Pour la changer : fichier config/.env du bureau, puis relancez l’installation.',
  'adm.acc.kie.keyLabel': 'Clé API Kie.ai',
  'adm.acc.kie.keyHint': 'Collez la clé de la page API Key de kie.ai. Elle est gardée sur le serveur et n’est plus jamais affichée.',
  'adm.acc.kie.keyPlaceholder': 'clé API Kie.ai',
  'adm.acc.kie.keyRequired': 'Collez la clé.',
  'adm.acc.kie.keyInvalid': 'Clé invalide : 16 à 200 caractères parmi lettres, chiffres, « . », « - » et « _ ».',
  'adm.acc.kie.saved': 'Clé Kie.ai enregistrée.',
  'adm.acc.kie.savedEnv': 'Clé Kie.ai enregistrée, mais la variable {env} passe avant elle : elle ne servira que si la variable est retirée.',
  'adm.acc.kie.alsoStored': 'Une clé est aussi enregistrée ici (inutilisée tant que la variable est définie).',
  'adm.acc.kie.removeAria': 'Supprimer la clé Kie.ai enregistrée',
  'adm.acc.kie.removeTitle': 'Supprimer la clé Kie.ai ?',
  'adm.acc.kie.removeText': 'Les agents réglés sur Kie.ai (vidéo) échoueront tant qu’aucune clé n’est disponible.',
  'adm.acc.kie.removed': 'Clé Kie.ai supprimée.',
  'adm.acc.kie.createKey': 'Obtenir une clé sur kie.ai',
  'adm.acc.kie.free': 'Chaque vidéo coûte des crédits Kie.ai, à la seconde selon le modèle (Seedance 2.0 en 720p : environ 41 crédits par seconde ; MiniMax H3 en 768P : environ 8 ; prix de kie.ai) ; une musique Suno V6, par demande (la tâche indique les crédits utilisés). Les fichiers joints (images, vidéos, sons) sont envoyés par des liens signés vers le bureau.',
  'adm.acc.gemini.stored': 'Clé enregistrée {hint}',
  'adm.acc.gemini.env': 'Clé définie dans Railway ({env})',
  'adm.acc.gemini.envLocal': 'Clé définie dans l’environnement du bureau ({env})',
  'adm.acc.gemini.none': 'Pas de clé',
  'adm.acc.gemini.unknown': 'État inconnu',
  'adm.acc.gemini.envHint': 'Elle passe avant une clé enregistrée ici. Pour la changer ou la retirer : Railway → Variables.',
  'adm.acc.gemini.envHintLocal': 'Elle passe avant une clé enregistrée ici. Pour la changer : fichier config/.env du bureau, puis relancez l’installation.',
  'adm.acc.gemini.keyLabel': 'Clé API Gemini',
  'adm.acc.gemini.keyHint': 'Collez la clé créée sur Google AI Studio (elle commence par AIza ou AQ.). Elle est gardée sur le serveur et n’est plus jamais affichée.',
  'adm.acc.gemini.keyPlaceholder': 'AIza… ou AQ.…',
  'adm.acc.gemini.keyRequired': 'Collez la clé.',
  'adm.acc.gemini.keyInvalid': 'Clé invalide : 20 à 200 caractères parmi lettres, chiffres, « - » et « _ ».',
  'adm.acc.gemini.saved': 'Clé Gemini enregistrée.',
  'adm.acc.gemini.savedEnv': 'Clé Gemini enregistrée, mais la variable {env} passe avant elle : elle ne servira que si la variable est retirée.',
  'adm.acc.gemini.alsoStored': 'Une clé est aussi enregistrée ici (inutilisée tant que la variable est définie).',
  'adm.acc.gemini.removeAria': 'Supprimer la clé Gemini enregistrée',
  'adm.acc.gemini.removeTitle': 'Supprimer la clé Gemini ?',
  'adm.acc.gemini.removeText': 'Les agents réglés sur Gemini échoueront tant qu’aucune clé n’est disponible.',
  'adm.acc.gemini.removed': 'Clé Gemini supprimée.',
  'adm.acc.gemini.createKey': 'Créer une clé gratuite',
  'adm.acc.gemini.free': 'La formule gratuite d’AI Studio suffit pour essayer (requêtes limitées par jour). Google peut alors utiliser les contenus envoyés pour améliorer ses services : pas de documents confidentiels, ou activez la facturation de la clé.',
  'adm.acc.manual.title': 'Procédure manuelle (Terminal)',
  'adm.acc.manual.intro': 'Si les boutons ne fonctionnent pas : connectez les comptes depuis le Terminal de votre ordinateur, par railway ssh.',
  'adm.acc.manual.install': 'Installer l’outil Railway sur votre ordinateur',
  'adm.acc.manual.installHint': 'Une seule fois. Sans Homebrew : npm install -g @railway/cli.',
  'adm.acc.manual.link': 'Se connecter au projet',
  'adm.acc.manual.linkHint': 'railway link demande l’espace de travail, le projet, l’environnement production et le service office.',
  'adm.acc.manual.ssh': 'Entrer dans le serveur',
  'adm.acc.manual.sshHint': 'Tout ce que vous tapez ensuite s’exécute chez Railway.',
  'adm.acc.manual.claude': 'Connecter Claude',
  'adm.acc.manual.claudeHint': 'Ouvrez le lien affiché, autorisez, puis recollez le code dans le Terminal.',
  'adm.acc.manual.check': 'Vérifier',
  'adm.acc.manual.checkHint': 'Liste les connecteurs que les agents pourront utiliser.',
  'adm.acc.manual.codex': 'Connecter ChatGPT (Codex)',
  'adm.acc.manual.codexHint': 'Ouvrez l’adresse affichée, saisissez le code, attendez « Successfully logged in ».',
  'adm.acc.manual.exit': 'Sortir du serveur',
  'adm.acc.manual.doc': 'Guide complet : docs/DEPLOY-RAILWAY.md, section 7.',
  'adm.acc.local.title': 'Connexion dans le Terminal',
  'adm.acc.local.intro': 'Dans le Terminal de la machine du bureau (sur le Mac mini : l’app Terminal), avec le même utilisateur que le bureau.',
  'adm.acc.local.claude': 'Connecter Claude',
  'adm.acc.local.claudeCheck': 'Vérifier Claude',
  'adm.acc.local.codex': 'Connecter ChatGPT (Codex)',
  'adm.acc.local.codexCheck': 'Vérifier Codex',
  'adm.acc.local.doc': 'Guide complet : docs/DEPLOY-MACMINI.md, section 4 ; sur une instance Railway, docs/DEPLOY-RAILWAY.md, section 7.',

  // Tabs of the office's MCP server (docs/wip/SPEC-MCP.md §6), shown only when the server reports
  // features.mcp; the other admin.tabs.* labels live in the shell dictionary.
  'admin.tabs.mcp': 'Accès Claude (MCP)',
  'admin.tabs.data': 'Données',

  // Accès Claude (MCP) (web/ui/admin/mcp.js)
  'adm.mcp.title': 'Accès Claude (MCP)',
  'adm.mcp.intro': 'Une clé d’accès branche Claude (claude.ai, l’app Claude ou Claude Code) sur ce bureau par le connecteur « Maeck Office ». Claude agit au nom de la personne de la clé, avec exactement ses accès : une clé administrateur règle tout le bureau ; une clé personnelle n’a que les accès de son membre (ses étages et services, ses connecteurs autorisés), jamais plus. Chaque appel est inscrit au Journal.',
  'adm.mcp.count': { one: '{n} clé active', other: '{n} clés actives' },
  'adm.mcp.new': 'CRÉER UNE CLÉ',
  'adm.mcp.full': '{max} clés administrateur actives au plus : révoquez-en une d’abord (les clés personnelles restent possibles).',
  'adm.mcp.secretWarn': 'L’adresse d’une clé est un secret : quiconque la connaît agit dans le bureau au nom de la personne de la clé (en administrateur pour une clé administrateur). Ne la collez que dans claude.ai ; au moindre doute, révoquez la clé.',
  'adm.mcp.agentsNote': 'Les agents du bureau ne reçoivent jamais ce connecteur, même s’il apparaît dans le compte Claude qu’ils utilisent.',
  'adm.mcp.col.name': 'Nom',
  'adm.mcp.col.createdBy': 'Créée par',
  'adm.mcp.col.kind': 'Type',
  'adm.mcp.col.owner': 'Agit comme',
  'adm.mcp.kind.admin': 'ADMINISTRATEUR',
  'adm.mcp.kind.personal': 'PERSONNELLE',
  'adm.mcp.kindTitle.admin': 'Tous les droits d’administrateur, au nom de l’administrateur qui l’a créée.',
  'adm.mcp.kindTitle.personal': 'Exactement les accès de ce membre : ses étages et services, ses connecteurs autorisés.',
  'adm.mcp.createdByOther': 'créée par {name}',
  'adm.mcp.ownerInactive': 'INACTIVE',
  'adm.mcp.ownerInactiveHint': 'Le compte est désactivé, supprimé ou a changé de rôle : chaque appel avec cette clé est refusé.',
  'adm.mcp.ownerPending': 'EN ATTENTE',
  'adm.mcp.ownerPendingHint': 'Pas encore utilisable : {name} doit d’abord se connecter au bureau et choisir son mot de passe.',
  'adm.mcp.reason.user_disabled': 'compte désactivé',
  'adm.mcp.reason.user_deleted': 'compte supprimé',
  'adm.mcp.reason.role_changed': 'devenu administrateur',
  'adm.mcp.revokedWhy': 'Révoquée {when} ({reason})',
  'adm.mcp.col.createdAt': 'Le',
  'adm.mcp.col.lastUsed': 'Dernier usage',
  'adm.mcp.col.hint': 'Indice',
  'adm.mcp.hint': '…{hint}',
  'adm.mcp.hintTitle': 'Les 4 derniers caractères de l’adresse',
  'adm.mcp.revoke': 'Révoquer',
  'adm.mcp.revokeAria': 'Révoquer la clé « {name} »',
  'adm.mcp.revokeTitle': 'Révoquer la clé « {name} » ?',
  'adm.mcp.revokeText': 'Claude ne pourra plus utiliser cette adresse : le connecteur qui s’en sert cesse de fonctionner tout de suite. Pour le rebrancher, il faudra créer une nouvelle clé. Cette action est irréversible.',
  'adm.mcp.revokeOk': 'RÉVOQUER',
  'adm.mcp.revoked': 'Clé « {name} » révoquée.',
  'adm.mcp.revokedBadge': 'RÉVOQUÉE',
  'adm.mcp.revokedOn': 'Révoquée {when}',
  'adm.mcp.empty.title': 'Aucune clé',
  'adm.mcp.empty.text': 'Créez une clé pour brancher Claude sur le bureau.',
  'adm.mcp.unavailable': 'L’accès de Claude au bureau (MCP) n’est pas activé sur ce serveur.',
  'adm.mcp.createTitle': 'Nouvelle clé d’accès',
  'adm.mcp.createSubtitle': 'L’adresse du connecteur s’affichera une seule fois.',
  'adm.mcp.name': 'Nom de la clé',
  'adm.mcp.namePlaceholder': 'ex. claude.ai',
  'adm.mcp.nameHint': 'Pour la reconnaître dans cette liste et dans le Journal.',
  'adm.mcp.nameTaken': 'Une clé active porte déjà ce nom.',
  'adm.mcp.create': 'CRÉER LA CLÉ',
  'adm.mcp.created': 'Clé « {name} » créée.',
  'adm.mcp.createdFor': 'Clé « {name} » créée pour {owner}.',
  'adm.mcp.kind': 'Type d’accès',
  'adm.mcp.kindOpt.admin': 'Accès administrateur',
  'adm.mcp.kindOpt.personal': 'Accès personnel pour…',
  'adm.mcp.kindHint.admin': 'Claude agit en votre nom, avec tous les droits d’administrateur : régler les étages, les agents, les connecteurs, les tables…',
  'adm.mcp.kindHint.personal': 'Claude agit au nom de ce membre, avec exactement ses accès : ce qu’il peut voir, lancer, valider ou régler ici, et ses seuls connecteurs autorisés. Jamais plus.',
  'adm.mcp.adminFull': 'Accès administrateur : {max} clés actives au plus, révoquez-en une d’abord.',
  'adm.mcp.owner': 'Pour qui ?',
  'adm.mcp.ownerPick': 'Choisir un membre…',
  'adm.mcp.ownerHint': 'Un membre seulement (un administrateur utilise une clé administrateur), {max} clés actives au plus par personne.',
  'adm.mcp.ownerRequired': 'Choisissez la personne.',
  'adm.mcp.ownerLoading': 'Chargement des membres…',
  'adm.mcp.ownerUnavailable': 'Liste des membres indisponible : {error}',
  'adm.mcp.ownerNone': 'Aucun membre actif : créez d’abord son compte dans Utilisateurs (un administrateur utilise une clé administrateur).',
  'adm.mcp.ownerDisabled': '{name} (compte désactivé)',
  'adm.mcp.ownerAtMax': '{name} ({max} clés actives : maximum)',
  'adm.mcp.ownerTempPw': 'La clé ne fonctionnera qu’après le premier changement de mot de passe de {name}.',
  'adm.mcp.ownerRights': 'Avec cette clé, Claude pourra : {grants} ; connecteurs du bureau : {conns}.',
  'adm.mcp.personalWarn': 'L’adresse s’affichera une seule fois : transmettez-la à la personne par un canal sûr. Elle la colle dans son propre compte claude.ai ; elle peut voir et révoquer ses clés dans « Mon accès Claude (MCP) ».',
  'adm.mcp.secret.title': 'Adresse du connecteur',
  'adm.mcp.secret.subtitle': 'Clé « {name} »',
  'adm.mcp.secret.label': 'Adresse du connecteur (secrète)',
  'adm.mcp.secret.once': 'Elle ne sera plus jamais affichée : copiez-la maintenant.',
  'adm.mcp.secret.warn': 'Cette adresse est un secret : elle donne un accès administrateur au bureau. Ne la collez nulle part ailleurs que dans claude.ai (ni message, ni document, ni ticket).',
  'adm.mcp.secret.subtitleFor': 'Clé « {name} » de {owner}',
  'adm.mcp.secret.warnOther': 'Cette adresse est un secret : elle donne à Claude les accès de {name}, rien de plus. Transmettez-la à {name} par un canal sûr (de vive voix, gestionnaire de mots de passe), jamais dans un message ou un document partagé ; {name} la colle dans son propre compte claude.ai.',
  'adm.mcp.steps.titleFor': 'Sur le claude.ai de {name}',
  'adm.mcp.steps.title': 'Sur claude.ai',
  'adm.mcp.steps.path': 'Personnaliser → Connecteurs → + → Ajouter un connecteur personnalisé',
  'adm.mcp.steps.1': 'Ouvrez Personnaliser → Connecteurs.',
  'adm.mcp.steps.2': 'Cliquez sur « + », puis sur « Ajouter un connecteur personnalisé ».',
  'adm.mcp.steps.3': 'Nom : Maeck Office (exactement : c’est à ce nom, et à ses outils, que le bureau reconnaît le connecteur pour le tenir hors de portée des agents).',
  'adm.mcp.steps.4': 'Collez l’adresse dans le champ URL.',
  'adm.mcp.steps.5': 'Authentification : choisissez « Aucune connexion » (« No sign-in » en anglais) : la clé est déjà dans l’adresse, ne remplissez aucun champ OAuth. Puis cliquez sur « Ajouter ».',
  'adm.mcp.steps.trouble': 'claude.ai ouvre une page de connexion ou affiche une erreur d’autorisation ? Supprimez le connecteur et ajoutez-le de nouveau en choisissant « Aucune connexion ».',
  'adm.mcp.steps.after': 'Le connecteur apparaît aussi dans Claude Code (même compte) sous le nom « claude.ai Maeck Office ».',
  'adm.mcp.secret.done': 'J’AI COPIÉ L’ADRESSE',
  'adm.mcp.secret.unreachable': 'claude.ai ne pourra pas joindre cette adresse : il lui faut une adresse https publique. Donnez au serveur son adresse publique (OFFICE_PUBLIC_URL, ou le domaine Railway), révoquez cette clé puis créez-en une nouvelle.',

  // Données: the Tables du bureau (web/ui/admin/data.js)
  'adm.data.title': 'Données',
  'adm.data.intro': 'Les Tables du bureau : la mémoire de travail que les agents d’un étage partagent (ce qu’ils ont déjà trouvé, fait ou envoyé), pour ne pas refaire deux fois le même travail. Les agents y écrivent pendant leurs tâches, et ceux des autres étages peuvent aussi lire et modifier ces lignes ; ici, vous les consultez, corrigez ou complétez leurs lignes et faites le ménage.',
  'adm.data.floor': 'Étage',
  'adm.data.floorOption': '{name} ({n})',
  'adm.data.floorOptionGuest': '{name} (données de {host})',
  'adm.data.guest.title': '« {name} » utilise les données de « {host} »',
  'adm.data.guest.text': 'Ses agents lisent et écrivent les tables de l’étage « {host} » (Données de l’étage, dans Étages & services) : c’est là qu’elles se consultent et se modifient.',
  'adm.data.guest.open': 'Voir les tables de « {host} »',
  'adm.data.sharedWith': {
    one: 'Ces tables sont aussi celles de l’étage {list}, qui utilise les données de cet étage : la limite de tables vaut pour l’ensemble.',
    other: 'Ces tables sont aussi celles des étages {list}, qui utilisent les données de cet étage : la limite de tables vaut pour l’ensemble.',
  },
  'adm.data.count': { one: '{n} table', other: '{n} tables' },
  'adm.data.limits': 'Au plus {tables} tables par étage, {rows} lignes et {size} par table.',
  'adm.data.col.name': 'Table',
  'adm.data.col.description': 'Description',
  'adm.data.col.key': 'Colonne clé',
  'adm.data.col.rows': 'Lignes',
  'adm.data.col.updated': 'Mise à jour',
  'adm.data.col.createdAt': 'Ajoutée',
  'adm.data.col.by': 'Par',
  'adm.data.keyTitle': 'Une ligne dont la valeur de cette colonne existe déjà n’est pas ajoutée deux fois.',
  'adm.data.keyTag': 'CLÉ',
  'adm.data.size': 'Taille : {size}',
  'adm.data.open': 'Ouvrir et modifier',
  'adm.data.openAria': 'Ouvrir et modifier la table « {name} »',
  'adm.data.addRowShort': 'Ligne',
  'adm.data.addRowAria': 'Ajouter une ligne à la table « {name} »',
  'adm.data.more': 'Autres actions sur la table « {name} »',
  'adm.data.drop': 'Supprimer la table',
  'adm.data.dropAria': 'Supprimer la table « {name} »',
  'adm.data.noFloors.title': 'Aucun étage',
  'adm.data.noFloors.text': 'Les tables appartiennent à un étage : créez d’abord un étage.',
  'adm.data.empty.title': 'Aucune table sur cet étage',
  'adm.data.empty.text': 'Créez-en une avec « Nouvelle table ». Les agents qui ont l’accès « Tables du bureau » en écriture en créent aussi pendant leurs tâches, et Claude par le connecteur « Maeck Office ».',
  'adm.data.unavailable': 'Les Tables du bureau ne sont pas activées sur ce serveur.',
  'adm.data.rows': { one: '{n} ligne', other: '{n} lignes' },
  'adm.data.preview.first': 'Les {shown} premières lignes sur {total}.',
  'adm.data.preview.range': 'Lignes {from} à {to} sur {total}.',
  'adm.data.preview.prev': '{n} précédentes',
  'adm.data.preview.next': '{n} suivantes',
  'adm.data.preview.empty': 'Cette table est vide.',
  'adm.data.preview.gone': 'Cette table n’existe plus.',
  'adm.data.preview.columns': 'Colonnes',
  'adm.data.preview.noColumns': 'Aucune colonne pour le moment.',
  'adm.data.by.admin': 'Administrateur',
  'adm.data.yes': 'oui',
  'adm.data.no': 'non',
  'adm.data.select': 'Sélectionner la ligne {n}',
  'adm.data.selectAll': 'Sélectionner toutes les lignes affichées',
  'adm.data.deleteRows': 'Supprimer la sélection',
  'adm.data.deleteRowsN': 'Supprimer la sélection ({n})',
  'adm.data.deleteRowsTitle': { one: 'Supprimer {n} ligne de « {table} » ?', other: 'Supprimer {n} lignes de « {table} » ?' },
  'adm.data.deleteRowsText': 'Les agents ne les retrouveront plus : une ligne supprimée peut être ajoutée à nouveau lors d’une prochaine tâche. Cette action est irréversible.',
  'adm.data.rowsDeleted': { one: '{n} ligne supprimée.', other: '{n} lignes supprimées.' },
  'adm.data.editHint': 'Cliquez sur une case pour la modifier : Entrée enregistre, Échap annule.',
  'adm.data.newRowLine': 'Nouvelle ligne…',
  'adm.data.toolbar': 'Actions sur les lignes',
  'adm.data.cell.edit': 'Modifier « {col} », ligne {n} : {value}',
  'adm.data.cell.input': '« {col} », ligne {n} (Entrée pour enregistrer, Échap pour annuler)',
  'adm.data.cell.saved': '« {col} », ligne {n} : enregistré.',
  'adm.data.cell.number': 'Nombre attendu (par exemple 12 ou 3,5).',
  'adm.data.cell.tooLong': '{max} caractères au plus.',
  'adm.data.cell.keyRequired': 'La colonne clé ne peut pas être vide.',
  'adm.data.bool.empty': '— (vide)',
  'adm.data.type.text': 'texte',
  'adm.data.type.number': 'nombre',
  'adm.data.type.boolean': 'oui ou non',
  'adm.data.addRow': 'Ajouter une ligne',
  'adm.data.new': 'Nouvelle table',
  'adm.data.new.title': 'Nouvelle table',
  'adm.data.new.subtitle': 'Sur l’étage « {floor} »',
  'adm.data.new.name': 'Nom de la table',
  'adm.data.new.nameHint': 'Lettres minuscules, chiffres et tirets : les agents l’appellent par ce nom (ex. concurrents-us).',
  'adm.data.new.nameInvalid': 'Lettres minuscules (sans accents), chiffres et tirets, 60 caractères au plus.',
  'adm.data.new.nameTaken': 'Une table porte déjà ce nom sur cet étage.',
  'adm.data.new.description': 'À quoi sert-elle ?',
  'adm.data.new.descriptionHint': 'Les agents lisent cette phrase pour savoir quoi y noter (500 caractères au plus).',
  'adm.data.new.columns': 'Colonnes',
  'adm.data.new.columnsHint': 'Facultatif : sans colonnes, les premières lignes ajoutées les définissent. Avec des colonnes, seules celles-ci sont acceptées.',
  'adm.data.new.column': 'Nom de la colonne {n}',
  'adm.data.new.columnType': 'Type de la colonne {n}',
  'adm.data.new.columnRemove': 'Retirer la colonne {n}',
  'adm.data.new.columnAdd': 'Ajouter une colonne',
  'adm.data.new.columnInvalid': 'Colonne {n} : une lettre puis des lettres, chiffres ou « _ » (sans espaces ni accents).',
  'adm.data.new.columnDuplicate': 'Colonne « {name} » en double.',
  'adm.data.new.columnsMax': '{max} colonnes au plus.',
  'adm.data.new.key': 'Colonne clé',
  'adm.data.new.keyNone': '— aucune',
  'adm.data.new.keyHint': 'Facultatif : une ligne dont la valeur de cette colonne existe déjà n’est pas ajoutée deux fois (déclarez-la d’abord dans les colonnes).',
  'adm.data.new.submit': 'CRÉER LA TABLE',
  'adm.data.new.created': 'Table « {name} » créée.',
  'adm.data.addRow.title': 'Ajouter une ligne à « {table} »',
  'adm.data.addRow.submit': 'AJOUTER LA LIGNE',
  'adm.data.addRow.keyHint': 'colonne clé : obligatoire, une valeur qui n’est pas déjà dans la table',
  'adm.data.addRow.empty': 'Remplissez au moins un champ.',
  'adm.data.addRow.noColumns': 'Cette table n’a pas encore de colonnes : les agents les définissent en ajoutant leurs premières lignes.',
  'adm.data.rowAdded': 'Ligne ajoutée.',
  'adm.data.dropTitle':'Supprimer la table « {name} » ?',
  'adm.data.dropText': 'La table et ses lignes ({rows}) disparaissent. Les agents qui s’en servent la recréeront vide s’ils en ont besoin, et referont peut-être un travail déjà fait. Cette action est irréversible.',
  'adm.data.dropConfirmLabel': 'Pour confirmer, tapez le nom de la table',
  'adm.data.dropConfirmHint': 'Exactement : {name}',
  'adm.data.dropOk': 'SUPPRIMER LA TABLE',
  'adm.data.dropMismatch': 'Le nom ne correspond pas.',
  'adm.data.dropped': { one: 'Table « {name} » supprimée ({n} ligne).', other: 'Table « {name} » supprimée ({n} lignes).' },

  // Connectors: the built-in « Tables du bureau » (office_tables)
  'adm.conn.builtin': 'INTÉGRÉ',
  'adm.conn.builtinHint': 'Intégré au bureau : toujours disponible, pour les agents Claude et Codex. Le classement de ses outils est fixe.',
  'adm.conn.fixedHint': 'Classement fixe',

  // Audit log
  'adm.audit.title': 'Journal',
  'adm.audit.intro': 'Chaque action sensible est enregistrée : connexions, comptes, réglages, tâches, Atelier. Les secrets n’y figurent jamais.',
  'adm.audit.count': { one: '{n} entrée', other: '{n} entrées' },
  'adm.audit.countOf': '{n} sur {total}',
  'adm.audit.action': 'Action',
  'adm.audit.allActions': 'Toutes les actions',
  'adm.audit.user': 'Personne',
  'adm.audit.allUsers': 'Tout le monde',
  'adm.audit.system': 'Système',
  'adm.audit.search': 'Rechercher',
  'adm.audit.searchPlaceholder': 'cible, détail…',
  'adm.audit.col.when': 'Quand',
  'adm.audit.col.who': 'Qui',
  'adm.audit.col.action': 'Action',
  'adm.audit.col.target': 'Cible',
  'adm.audit.col.details': 'Détails',
  'adm.audit.empty': 'Aucune entrée ne correspond à ces filtres.',
  'adm.audit.emptyLog': 'Le journal est vide pour le moment.',
  'adm.audit.more': 'AFFICHER PLUS',
  'adm.audit.reset': 'Effacer les filtres',
  'adm.audit.unavailable': 'Le journal n’est pas encore disponible sur ce serveur.',
  'adm.audit.limit': 'Les 500 dernières entrées sont affichées.',

  // Activité (members' requests, discussions and actions; read-only)
  'adm.activity.title': 'Activité',
  'adm.activity.intro': 'Ce que les membres demandent et font, équipe par équipe.',
  'adm.activity.tip': 'Lecture seule : rien n’est approuvé ni modifié d’ici. Les demandes des 30 derniers jours, les actions récentes du journal.',
  'adm.activity.tipChats': 'Lecture seule : rien n’est approuvé ni modifié d’ici. Les demandes des 30 derniers jours, les discussions, les actions récentes du journal.',
  'adm.activity.tipAria': 'Ce que montre l’activité',
  'adm.activity.count': { one: '{n} élément', other: '{n} éléments' },
  'adm.activity.countMore': '{n} affichés',
  'adm.activity.person': 'Personne',
  'adm.activity.who.members': 'Tous les membres',
  'adm.activity.who.all': 'Tout le monde',
  'adm.activity.adminName': '{name} (administrateur)',
  'adm.activity.floor': 'Étage',
  'adm.activity.allFloors': 'Tous les étages',
  'adm.activity.dept': 'Service',
  'adm.activity.allDepts': 'Tous les services',
  'adm.activity.kind': 'Type',
  'adm.activity.kind.all': 'Tout',
  'adm.activity.kind.task': 'Demandes',
  'adm.activity.kind.chat': 'Discussions',
  'adm.activity.kind.action': 'Actions',
  'adm.activity.empty': 'Rien pour ces filtres.',
  'adm.activity.more': 'AFFICHER PLUS',
  'adm.activity.unavailable': 'L’activité n’est pas encore disponible sur ce serveur.',
  'adm.activity.today': 'Aujourd’hui',
  'adm.activity.yesterday': 'Hier',
  'adm.activity.unknownDay': 'Date inconnue',
  'adm.activity.noTeam': '—',
  'adm.activity.admin': 'admin',
  'adm.activity.gone': 'compte supprimé',
  'adm.activity.someone': 'Quelqu’un',
  'adm.activity.goneAgent': 'un agent supprimé',
  'adm.activity.untitled': 'Demande sans titre',
  'adm.activity.openTask': 'Ouvrir la tâche « {title} »',
  'adm.activity.openChat': 'Lire la discussion de {name} avec {agent}',
  'adm.activity.chatWith': 'Discussion avec {agent}',
  'adm.activity.files': { one: '{n} image', other: '{n} images' },
  'adm.activity.from.user': 'Demande',
  'adm.activity.from.chat': 'Depuis une discussion',
  'adm.activity.from.calendar': 'Depuis le calendrier',
  'adm.activity.from.routine': 'Routine lancée à la main',
  'adm.activity.from.trigger': 'Déclencheur lancé à la main',
  'adm.activity.chat.eyebrow': 'DISCUSSION · LECTURE SEULE',
  'adm.activity.chat.title': '{name} avec {agent}',
  'adm.activity.chat.readOnly': 'Lecture seule : la discussion de {name} avec {agent}. Rien ne peut être envoyé d’ici.',
  'adm.activity.chat.logLabel': 'Messages de la discussion',
  'adm.activity.chat.empty': 'Cette discussion est vide.',
  'adm.activity.chat.notFound': 'Discussion introuvable',
  'adm.activity.chat.notFoundText': 'Elle a été effacée, ou le serveur ne permet plus aux administrateurs de lire les discussions.',
  'adm.activity.chat.openImage': 'Agrandir l’image {name}',

  // Users → « Voir l’activité » of a person
  'adm.users.activity': 'Voir l’activité',
  'adm.users.activityAria': 'Voir l’activité de {name}',
});
